import React from 'react'
import _ from 'lodash'
import {AddDestination} from '../init/destination/add_destination.component'
import DetailsOverviewContainer from './detailsoverview.container'
import ItineraryOverviewContainer from '../itinerary/itineraryoverview.container'
import BookingContainer from '../booking/booking.container'

export const DETAIL_SECTION = {
    DESTINATION: 'DESTINATION',
    OVERVIEW: 'OVERVIEW',
    ACCOMMODATIONS: 'ACCOMMODATIONS',
    TRAVEL: 'TRAVEL',
    ACTIVITIES: 'ACTIVITIES',
    REVIEW: 'REVIEW',
    LUNA: 'LUNA'
}

export const DETAIL_SUB_SECTION = {
    OVERVIEW: 'OVERVIEW',
    CHOICE: 'CHOICE',
    SEARCH: 'SEARCH',
    ENTRY: 'ENTRY',
    DETAILS: 'DETAILS',
    LUNA: 'LUNA',
    AGENT: 'AGENT'
}

export const DETAIL_SUB_DETAIL = {
    ARRIVAL: 'ARRIVAL',
    LOCAL: 'LOCAL',
    DEPARTURE: 'DEPARTURE'
}

export class Details extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            activeAccommodation: props.activeAccommodation,
            activeActivity: props.activeActivity,
            activeTravel: props.activeTravel,
            detailSection: props.detailSection ? props.detailSection : DETAIL_SECTION.DESTINATION,
            detailSubSection: props.detailSubSection ? props.detailSubSection : DETAIL_SUB_SECTION.OVERVIEW,
            detailSubDetail: props.detailSubDetail ? props.detailSubDetail : null,
            availableDetailSections: DETAIL_SECTION,
            availableDetailSubSections: DETAIL_SUB_SECTION,
            availableDetailSubDetails: DETAIL_SUB_DETAIL
        }

        _.bindAll(this,
            'updateDetailSections',
            'updateDeepLink',
            'getContent'
        )
    }

    // componentWillReceiveProps(nextProps) {
    //   let oldLeg = this.props.leg ? this.props.leg.getIn(['id']) : null
    //   let newLeg  = nextProps.leg ? nextProps.leg.getIn(['id']) : null
    //   //if we've changed legs and we weren't just on the itinerary overview (leg not set), refresh to the overview
    //   if(oldLeg !== newLeg && oldLeg){
    //     this.updateDetailSections(nextProps.leg, this.state.detailSection, this.state.detailSubSection, this.state.detailSubDetail)
    //   }
    // }

    componentDidUpdate(prevProps, prevState) {
        let oldLeg = prevProps.leg ? prevProps.leg.get('id') : null
        let newLeg = this.props.leg ? this.props.leg.get('id') : null
    
        // if we've changed legs and we weren't just on the itinerary overview (leg not set), refresh to the overview
        if (oldLeg !== newLeg && oldLeg) {
            this.updateDetailSections(this.props.leg, this.props.detailSection, this.props.detailSubSection, this.props.detailSubDetail)
        } else {
            this.updateDeepLink(this.props.leg, this.props.detailSection, this.props.detailSubSection, this.props.detailSubDetail)      
        }
    }  

    updateDeepLink(leg, section, subsection, subdetail) {
    // match the active object to the active section
        let activeObj = null
        if (subsection != 'DETAILS') {
            // do nothing we want it null
        } else if (section == 'ACCOMMODATIONS') {
            activeObj = this.props.activeAccommodation
        } else if (section == 'ACTIVITIES') {
            activeObj = this.props.activeActivity
        } else if (section == 'TRAVEL') {
            activeObj = this.props.activeTravel
        }       

        if (subsection == 'DETAILS' && activeObj == null ) {
            // don't push update
        } else {
            this.props.onUpdateDeepLink(leg, section, subsection, subdetail, activeObj)
        }
    }

    updateDetailSections(leg, section, subsection, subdetail) {
        this.props.onActivateLeg(leg)
        // submit the presence change
        if (this.state.detailSection !== section) {
            this.props.onChangeDetailsSection(status)
        }    

        // submit the change to update the UI
        this.updateDeepLink(leg, section, subsection, subdetail)
        this.props.onChangeDetailsUI(section, subsection, subdetail)
    }

    getContent() {
        if (this.props.bookingActive) {
            return <BookingContainer 
        onToggleBooking={this.props.onToggleBooking} 
        
        {...this.props}

        updateDetailSections={this.updateDetailSections}

        availableDetailSections={this.state.availableDetailSections}
        availableDetailSubSections={this.state.availableDetailSubSections}
        availableDetailSubDetails={this.state.availableDetailSubDetails}/>
        } else if (!this.props.leg) {
            return <ItineraryOverviewContainer
        {...this.props}

        updateDetailSections={this.updateDetailSections}

        availableDetailSections={this.state.availableDetailSections}
        availableDetailSubSections={this.state.availableDetailSubSections}
        availableDetailSubDetails={this.state.availableDetailSubDetails}/>
        } else if (!this.props.leg.getIn(['destination', 'hasLocation'])) {
            return <AddDestination 
        {...this.props} 
        updateDetailSections={this.updateDetailSections}
        availableDetailSections={this.state.availableDetailSections}
        availableDetailSubSections={this.state.availableDetailSubSections}/>
        } else {
            return <DetailsOverviewContainer
        {...this.props}
        
        updateDetailSections={this.updateDetailSections}

        availableDetailSections={this.state.availableDetailSections}
        availableDetailSubSections={this.state.availableDetailSubSections}
        availableDetailSubDetails={this.state.availableDetailSubDetails}/>
        }
    }

    render() {
        return (
            <div className="details-container">
                {this.getContent()}
            </div>
        )
    }
}
